namespace nscs.scene {
    export class Preloader extends Phaser.Scene {

        preload() {
            this.load.atlas(nscs.screen.Preloader.ATLAS, 'assets/imgs/atlas/'+nscs.screen.Preloader.ATLAS+'.png', 'assets/imgs/atlas/'+nscs.screen.Preloader.ATLAS+'.json');
        }

        create() {
            let p:nscs.screen.Preloader = new nscs.screen.Preloader(this);
            this.children.add(p);

            this.load.json('data', 'assets/json/data.json');
            this.load.pack('preloader', 'assets/pack.json');

            this.load.on('progress', (value:number) => {
                p.updateProgress(value);
            }, this);

            this.load.on('complete', () => {
                this.nextScene();
            });

            this.load.start();
        }

        private nextScene():void {
            game.scene.remove('Preloader');
            game.scene.add('MainScene', nscs.scene.MainScene, true);
        }
    }
}